<!-- <ion-scroll scrollX="true"> -->
  <event-box class="event-box" *ngFor="let event of events | slice:0:10" [event]="event" (click)="onOrderEventNowClick.emit({ funz: funz, event: event })"></event-box>
  <div class="event-box total-events-left" *ngIf="events.length > 10" (click)="onMoreDatesClick.emit()">
    <span>{{ 'components.event-scroll.more' | translate}}</span>
    <span>{{ 'components.event-scroll.dates' | translate}}</span>
  </div>
<!-- </ion-scroll> -->